import { EmailsSortByDto, SortDirectionDto } from '@/api/generated';
import {
  EmailDialogsTranslation,
  emailDialogsTranslation,
} from '@/assets/locales/views/emails/dialogs/emailDialogs.translation.pl.ts';
import {
  NewEmailTranslation,
  newEmailTranslation,
} from '@/assets/locales/views/emails/newEmail/newEmail.translation.pl.ts';
import {
  threadEmailsTranslation,
  ThreadEmailsTranslation,
} from '@/assets/locales/views/emails/threadEmails/threadEmails.translation.pl.ts';
import {
  threadsListTranslation,
  ThreadsListTranslation,
} from '@/assets/locales/views/emails/threadsList/threadsList.translation.pl.ts';

export type EmailsViewTranslation = {
  dialogs: EmailDialogsTranslation;
  folders: {
    filterFoldersPlaceholder: string;
    modals: {
      clean: {
        button: {
          clean: string;
        };
        content: string;
        title: string;
      };
    };
  };
  header: {
    sortBy: WithTitle & Record<EmailsSortByDto, string>;
    sortOrder: WithTitle & Record<SortDirectionDto, string>;
  };
  messages: { notYourEmail: string };
  newEmail: NewEmailTranslation;
  threadEmails: ThreadEmailsTranslation;
  threadsList: ThreadsListTranslation;
  toasts: {
    sendError: string;
    sendSuccess: string;
  };
};

type WithTitle = {
  title: string;
};

export const emailsViewTranslation: EmailsViewTranslation = {
  dialogs: emailDialogsTranslation,
  folders: {
    filterFoldersPlaceholder: 'Znajdź folder',
    modals: {
      clean: {
        button: {
          clean: 'Wyczyść',
        },
        content: 'Czy na pewno chcesz wyczyścić folder?',
        title: 'Potwierdź czyszczenie folderu',
      },
    },
  },
  header: {
    sortBy: {
      [EmailsSortByDto.Date]: 'Data',
      [EmailsSortByDto.From]: 'Od',
      [EmailsSortByDto.Subject]: 'Temat',
      [EmailsSortByDto.To]: 'Do',
      title: 'Sortuj po:',
    },
    sortOrder: {
      [SortDirectionDto.Asc]: 'Rosnąco',
      [SortDirectionDto.Desc]: 'Malejąco',
      title: 'Kierunek sortowania:',
    },
  },
  messages: {
    notYourEmail:
      'Email innego użytkownika. Jeżeli chcesz wziąć udział w konwersacji napisz nową wiadomość',
  },
  newEmail: newEmailTranslation,
  threadEmails: threadEmailsTranslation,
  threadsList: threadsListTranslation,
  toasts: {
    sendError: 'Wystąpił błąd podczas wysyłania emaila',
    sendSuccess: 'Email został wysłany',
  },
};
